import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import HeaderOfPage from '../tools/headerOfPage';
import changeUrl from "../../hoc/changeur";
import ImageUploader from '../tools/uploaderImage';

export default function EditGiftProduct() {
    const { t } = useTranslation();
    let cookie = getCookies();
    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [data, setData] = React.useState<any>(null);
    const [activeLang, setActiveLang] = useState<string>('en');
    const [saving, setSaving] = useState<boolean>(false);
    const [languages, setLanguages] = useState<Array<{ code: string; label: string }>>([]);

    const loadLanguages = async (): Promise<Array<{ code: string; label: string }>> => {
        try {
            const res = await axios.get(`${config.url}/v1/language`);
            const languageList = res.data?.message ?? [];
            const mapped = languageList
                .filter((lang: any) => lang.active)
                .sort((a: any, b: any) => (a.arranged ?? 0) - (b.arranged ?? 0))
                .map((lang: any) => ({ code: lang.code, label: lang.label }));
            setLanguages(mapped);
            if (mapped.length > 0) {
                setActiveLang(mapped[0].code);
            }
            return mapped;
        } catch (e) {
            console.error('Error loading languages:', e);
            const fallback = [
                { code: 'ku', label: 'Kurdish' },
                { code: 'fa', label: 'فارسی' },
                { code: 'en', label: 'English' },
                { code: 'ar', label: 'العربية' },
                { code: 'tr', label: 'Türkçe' }
            ];
            setLanguages(fallback);
            return fallback;
        }
    };

    const initializeMultilingualField = (field: any, languageCodes: string[]): any => {
        if (!field) {
            const obj: any = {};
            languageCodes.forEach(code => obj[code] = '');
            return obj;
        }
        if (typeof field === 'string') {
            const obj: any = {};
            languageCodes.forEach(code => obj[code] = field);
            return obj;
        }
        if (typeof field === 'object') {
            if (field.nl) {
                field.ku = field.nl;
                delete field.nl;
            }
            const obj: any = { ...field };
            languageCodes.forEach(code => { if (obj[code] == null) obj[code] = ''; });
            return obj;
        }
        const obj: any = {};
        languageCodes.forEach(code => obj[code] = '');
        return obj;
    };

    const langList = languages.length > 0 ? languages : [
        { code: 'ku', label: 'Kurdish' },
        { code: 'fa', label: 'فارسی' },
        { code: 'en', label: 'English' },
        { code: 'ar', label: 'العربية' },
        { code: 'tr', label: 'Türkçe' }
    ];

    const save = async () => {
        setSaving(true);
        try {
            var path = `${config.url}/v1/dashboard/giftproducts/${Id}`;
            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            
            Swal.fire({
                icon: 'success',
                title: t('Success'),
                text: 'محصول هدیه با موفقیت به‌روزرسانی شد',
                timer: 1500,
                showConfirmButton: false
            });
        } catch (error: any) {
            let errorMessage = 'خطا در به‌روزرسانی محصول هدیه';
            if (error.response?.data?.message) {
                const msg = error.response.data.message;
                if (typeof msg === 'string') {
                    errorMessage = msg;
                } else if (typeof msg === 'object') {
                    if (msg.message) {
                        errorMessage = typeof msg.message === 'string' ? msg.message : String(msg.message);
                    } else if (msg._message) {
                        errorMessage = typeof msg._message === 'string' ? msg._message : String(msg._message);
                    } else {
                        errorMessage = JSON.stringify(msg);
                    }
                } else {
                    errorMessage = String(msg);
                }
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        } finally {
            setSaving(false);
        }
    }

    const load = async (languageCodes: string[] = []) => {
        try {
            var path = `${config.url}/v1/dashboard/giftproducts/${Id}`;
            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const loadedData = res.data.message;
            const codes = languageCodes.length > 0
                ? languageCodes
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            if (loadedData) {
                loadedData.name = initializeMultilingualField(loadedData.name, codes);
                loadedData.url = initializeMultilingualField(loadedData.url, codes);
            }
            setData(loadedData)
        } catch (error: any) {
            let errorMessage = 'خطا در بارگذاری محصول هدیه';
            if (error.response?.data?.message) {
                errorMessage = typeof error.response.data.message === 'string' 
                    ? error.response.data.message 
                    : 'خطا در بارگذاری';
            }
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: errorMessage,
            });
        }
    }

    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/Products'
        },
        {
            name: 'Gift Products',
            url: '/dashboard/Products/GiftProducts'
        },
        {
            name: 'Edit Gift Product',
            url: null
        }
    ]

    useEffect(() => {
        const initialize = async () => {
            const loadedLanguages = await loadLanguages();
            const languageCodes = loadedLanguages.length > 0
                ? loadedLanguages.map(l => l.code)
                : ['ku', 'fa', 'en', 'ar', 'tr'];
            await load(languageCodes);
        };
        initialize();
    }, []);

    useEffect(() => {
        if (languages.length > 0 && data) {
            const languageCodes = languages.map(l => l.code);
            const updatedData = { ...data };
            updatedData.name = initializeMultilingualField(data.name, languageCodes);
            updatedData.url = initializeMultilingualField(data.url, languageCodes);
            setData(updatedData);
        }
    }, [languages.length]);

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="ویرایش محصول هدیه"></HeaderOfPage>

            {data != null && (
                <div className="mt-6">
                    <div className="bg-white rounded-xl shadow-sm p-6" dir="rtl">
                        <form key={key}>
                            {/* Language Selector */}
                            <div className="mb-6">
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    زبان / Language
                                </label>
                                <div className="flex gap-2 flex-wrap">
                                    {langList.map((lang) => (
                                        <button
                                            key={lang.code}
                                            type="button"
                                            onClick={() => setActiveLang(lang.code)}
                                            className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                                                activeLang === lang.code
                                                    ? 'bg-blue-600 text-white'
                                                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                                            }`}
                                        >
                                            {lang.label}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        {t('Name')} ({langList.find(l => l.code === activeLang)?.label}) <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        value={data.name?.[activeLang] || ''}
                                        type="text"
                                        className={`${inputstyle} ${error != null && error['name'] != undefined ? 'bg-red-100' : ''}`}
                                        placeholder="نام محصول هدیه"
                                        onChange={(e) => {
                                            const nameValue = e.target.value;
                                            const slugValue = changeUrl(nameValue);
                                            setData({ 
                                                ...data, 
                                                name: { 
                                                    ...data.name, 
                                                    [activeLang]: nameValue 
                                                },
                                                url: {
                                                    ...data.url,
                                                    [activeLang]: slugValue
                                                }
                                            });
                                        }}
                                    />
                                    {error != null && error['name'] != undefined && (
                                        <small className="text-red-500">{error['name']['message']}</small>
                                    )}
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        URL ({langList.find(l => l.code === activeLang)?.label})
                                    </label>
                                    <input
                                        type="text"
                                        value={data.url?.[activeLang] || ''}
                                        className={`${inputstyle} ${error != null && error['url'] != undefined ? 'bg-red-100' : ''}`}
                                        placeholder="product-gift-url"
                                        onChange={(e) => setData({ 
                                            ...data, 
                                            url: { 
                                                ...data.url, 
                                                [activeLang]: e.target.value 
                                            } 
                                        })}
                                    />
                                    {error != null && error['url'] != undefined && (
                                        <small className="text-red-500">{error['url']['message']}</small>
                                    )}
                                </div>
                                <ImageUploader id={data._id} component="giftproduct"></ImageUploader>
                                    
                                <div className="pt-4">
                                    <button
                                        type="button"
                                        onClick={save}
                                        disabled={saving}
                                        className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                                    >
                                        {saving ? 'در حال ذخیره...' : t('Update')}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    )
}

